import { render } from "./StartScreenPage.vue?vue&type=template&id=6d705af2"
import script from "./StartScreenPage.vue?vue&type=script&lang=js"
export * from "./StartScreenPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__